export const GET_REQUIREMENT_SUCCESS = "GET_REQUIREMENT_SUCCESS";
export const GET_REQUIREMENT_ERROR = "GET_REQUIREMENT_ERROR";

export const VIEW_REQUIRE_SUCCESS = "VIEW_REQUIRE_SUCCESS";
export const VIEW_REQUIRE_ERROR = "VIEW_REQUIRE_ERROR";


export const HIDE_SHOW_SUCCESS = "HIDE_SHOW_SUCCESS";
export const HIDE_SHOW_ERROR = "HIDE_SHOW_ERROR";


